<template>
  <div>
    <LoadingSpinner />
    <router-view />
  </div>
</template>
<script>
import LoadingSpinner from "@/component/LoadingSpinner.vue";

export default {
  components: { LoadingSpinner },
};
</script>



